import React from "react";
import { graphql } from 'gatsby';
import SEO from '../components/Seo';
import Layout from "../components/Layout";
import MapContainer from "../components/MapContainer/MapContainer";
import Header from "../components/Header/Header";

const MapPage = ({
  data: {
    allStrapiMap: { nodes: map },
    allStrapiProducers: { nodes: producersLocations }
  }
}) => {

  const { header, headerImage } = map[0];

  return (
    <Layout>
      <SEO
        pageTitle={'Rota dos produtores'}
        description={'Página oficial da Feira do Vinho do Dão - programa, imagens e noticias ao momento'}
      />
      <Header
        title={header.title}
        subtitle={header.subtitle}
        image={headerImage}
      />
      <MapContainer producers={producersLocations} />
    </Layout>
  );
}

export const query = graphql`
  {
    allStrapiMap {
      nodes {
        header {
          title
          subtitle
        }
        headerImage {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    allStrapiProducers {
      nodes {
        location {
          latitude
          longitude
        }
        id
        mapOnly
        name
        logo {
          publicURL
        }
        email
        description
        address
        slug
      }
    }
  }
`;

export default MapPage;
